module.exports = __webpack_public_path__ + "static/img/two.ce42899.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/3/two.png
// module id = VpqX
// module chunks = 1